import App from '../components/App';
import * as mapActions from '../actions/map';
import * as locationActions from '../actions/location';
import * as appActions from '../actions/app';
import * as aoiActions from '../actions/aoi';
import * as poiActions from '../actions/poi';
import { connect } from 'react-redux';
import * as constants from '../constants/map';

function mapStateToProps(state) {
  return {
    activeRenderer: state.map.renderer,
    renderers: [
      constants.RENDERER_SVG,
      //constants.RENDERER_THREE,
    ],
    availableMaps: state.map.availableMaps,
    aois: state.aois,
    pois: state.pois,
    error: state.app.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setRenderer: (renderer) => dispatch(mapActions.setRenderer(renderer)),
    setAvailableMaps: (maps) => dispatch(mapActions.setAvailableMaps(maps)),
    setSelectedMap: (map) => dispatch(mapActions.setSelectedMap(map)),
    setAois: (aois) => dispatch(aoiActions.setAois(aois)),
    setPois: (pois) => dispatch(poiActions.setPois(pois)),
    setOrigin: (origin) => dispatch(mapActions.setOrigin(origin)),
    setLocatable: (locatable) => dispatch(locationActions.setLocatable(locatable)),
    removeLocatable: (locatable) => dispatch(locationActions.removeLocatable(locatable)),
    setError: (error) => dispatch(appActions.setError(error)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js